import { render } from "./AddPollPage.vue?vue&type=template&id=210eee5c&scoped=true"
import script from "./AddPollPage.vue?vue&type=script&lang=js"
export * from "./AddPollPage.vue?vue&type=script&lang=js"

import "./AddPollPage.vue?vue&type=style&index=0&id=210eee5c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210eee5c"]])

export default __exports__